import React, { useEffect } from "react";
import Accordion from "../Accordion/Accordion";
import SaleCard from "./SaleCard";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setCategory, setGender, setSideMenuBarOpen, setSubCategory } from "../../appState/slices/auth/authSlice";
import { getCollections } from "../../appState/slices/categories/categorySlice";
const Men = ({ categories,gender }) => {
    const collections = useSelector((state) => state.category.collections);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(setGender(gender));
    })
    const openSaleList = async() => {
        await dispatch(setSideMenuBarOpen(false));
        navigate(`productlist/discount/${true}`);

    }
    const openProductList = async(subcategory,category) => {
        await dispatch(setSideMenuBarOpen(false));
        await dispatch(setSubCategory(subcategory._id));
        await dispatch(setCategory(category._id)) 
        navigate(`productlist/${gender}/${category._id}/${subcategory._id}`);
    }
    return (
        <div className="tabcontent">
            <div className="div-accordion">
                {categories.map(category => {
                    return (
                        <Accordion title={category.name}>
                            <div className="content">
                                {category.children.map(subcategory => {
                                    return (
                                        <React.Fragment>
                                           <p className="singlecontent"><Link onClick={() => openProductList(subcategory,category)} className="sidemenu-link" >{subcategory.name}</Link></p>
                                        </React.Fragment>
                                    )
                                })}
                            </div>
                        </Accordion>
                    )
                })}
            </div>
            <div>
                {/* <div className="collections">
                <p className="title font-semibold t1"><Link onClick={openSaleList} className="sidemenu-link" >SALE</Link></p>
                    <div className="horizontalscroll">
                    <div className="card-flex">
                        {collections.map(saledetails => {
                            return(
                                <div className="col-lg-3 col-md-6 col-sm-6">
                                <SaleCard saledetails={saledetails} />
                            </div>
                            )
                        })}
                    </div>
                </div>
                    </div> */}
                    </div>
                </div>
                
    )
}

export default Men;